"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var SentenceTranslateCardWrapper = function SentenceTranslateCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "focusedWordAssociationId", _descriptor, _this);
      _initializerDefineProperty(_this, "cardId", _descriptor2, _this);
      _initializerDefineProperty(_this, "caretPosition", _descriptor3, _this);
      _initializerDefineProperty(_this, "submittedAnswer", _descriptor4, _this);
      _initializerDefineProperty(_this, "submittedInputValuesCorrect", _descriptor5, _this);
      _initializerDefineProperty(_this, "loadingSentenceHasTimedOut", _descriptor6, _this);
      _initializerDefineProperty(_this, "showAccentWarning", _descriptor7, _this);
      _initializerDefineProperty(_this, "showSynonymWarning", _descriptor8, _this);
      _initializerDefineProperty(_this, "showMultipleWordsWarning", _descriptor9, _this);
      _initializerDefineProperty(_this, "showLetterCaseWarning", _descriptor0, _this);
      _initializerDefineProperty(_this, "nextCardWasClicked", _descriptor1, _this);
      _this.onInputChange = function (val, wordAssociationId) {
        if (_this.props.cardState.revealed || _this.props.cardState.pendingReveal) return;
        var targetText = _this.targetByWordAssociationId(wordAssociationId);
        if (!(0, _utils.isPresent)(targetText)) {
          return;
        }
        _this.nextCardWasClicked = false;
        _this.props.cardState.inputValues[wordAssociationId] = val;
        if (!targetText.includes(' ')) {
          _this.props.cardState.inputValues[wordAssociationId] = _this.props.cardState.inputValues[wordAssociationId].trim();
        }
        if (_this.inputValuesCorrect && _this.evaluateVocabOnKeystroke) {
          _this.onCorrectAnswer();
        } else if (_this.inputValuesCorrectWithoutAccents && _this.evaluateVocabOnKeystroke) {
          _this.showAccentWarning = true;
        } else if (_this.inputValuesCorrectWithoutCasing && _this.evaluateVocabOnKeystroke) {
          _this.showLetterCaseWarning = true;
        } else if (_this.showMultipleWordsWarning && _this.inputNeedsMoreWords) {
          _this.showLetterCaseWarning = false;
          _this.showAccentWarning = false;
        } else {
          _this.resetWarnings();
        }
      };
      _this.onCorrectAnswer = function () {
        _state.DeckUI.onCorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, {
          xp: 2,
          xpSlug: 'exercise'
        });
        _state.DeckUI.reveal(_this.props.card, _this.props.cardState);
        _this.submittedInputValuesCorrect = _this.inputValuesCorrect;
        _this.submittedAnswer = true;
        _this.resetWarnings();
      };
      _this.onShowAnswer = function () {
        if (_this.inputValuesCorrect) {
          _this.onCorrectAnswer();
        } else if (_this.inputValuesCorrectWithoutAccents && !_this.evaluateVocabOnKeystroke && !_this.showAccentWarning) {
          _this.showAccentWarning = true;
        } else if (_this.inputValuesCorrectWithoutCasing && !_this.evaluateVocabOnKeystroke && !_this.showLetterCaseWarning) {
          _this.showLetterCaseWarning = true;
        } else if (_this.inputNeedsMoreWords && !_this.showMultipleWordsWarning) {
          _this.showMultipleWordsWarning = true;
        } else if (_this.inputValuesMatchSynonym && !_this.showSynonymWarning) {
          _this.showSynonymWarning = true;
        } else {
          _this.resetWarnings();
          _state.DeckUI.reveal(_this.props.card, _this.props.cardState);
        }
      };
      _this.onSubmit = function () {
        var _this$props;
        if ((_this$props = _this.props) !== null && _this$props !== void 0 && (_this$props = _this$props.cardState) !== null && _this$props !== void 0 && _this$props.revealed) {
          _this.onNextClick();
        } else {
          _this.onShowAnswer();
        }
      };
      _this.onInputFocus = function (wordAssociationId) {
        if (_this.focusedWordAssociationId !== wordAssociationId) {
          _this.focusedWordAssociationId = wordAssociationId;
          _this.caretPosition = _this.props.cardState.inputValues[wordAssociationId] ? _this.props.cardState.inputValues[wordAssociationId].length : 0;
        }
      };
      _this.onCaretPositionChange = function (caretPosition) {
        _this.caretPosition = caretPosition;
      };
      _this.onCharacterClick = function (character) {
        var caretPosition;
        if (_this.focusedWordAssociationId) {
          if (_state.AppUI.layout.isNative) {
            caretPosition = _this.caretPosition;
          } else {
            var el = document.getElementById(_this.focusedWordAssociationId);
            if (el) {
              caretPosition = el.selectionStart;
            }
          }
          var oldValue = _this.props.cardState.inputValues[_this.focusedWordAssociationId] || '';
          var newValue = [oldValue.slice(0, caretPosition), character, oldValue.slice(caretPosition)].join('');
          _this.props.cardState.inputValues[_this.focusedWordAssociationId] = newValue;
          _this.caretPosition = caretPosition + 1;
          _this.onInputChange(newValue, _this.focusedWordAssociationId);
        }
      };
      _this.wordAssociationById = function (wordAssociationId) {
        var _this$props$card;
        if ((0, _utils.isPresent)((_this$props$card = _this.props.card) === null || _this$props$card === void 0 || (_this$props$card = _this$props$card.sentence) === null || _this$props$card === void 0 ? void 0 : _this$props$card.wordAssociations) && wordAssociationId) {
          return _this.props.card.sentence.wordAssociations.find(function (item) {
            return item.id === wordAssociationId;
          });
        }
      };
      _this.targetByWordAssociationId = function (wordAssociationId) {
        var wordAssociation = _this.wordAssociationById(wordAssociationId);
        if (wordAssociation) {
          var _wordAssociation$word;
          var targetText = ((_wordAssociation$word = wordAssociation.word) === null || _wordAssociation$word === void 0 ? void 0 : _wordAssociation$word.targetText) || wordAssociation.targetText;
          if (!(0, _utils.isPresent)(targetText)) {
            return;
          }
          return wordAssociation.firstInSentence ? (targetText === null || targetText === void 0 ? void 0 : targetText.substring(0, 1).toUpperCase()) + (targetText === null || targetText === void 0 ? void 0 : targetText.substring(1)) : wordAssociation.targetText;
        }
      };
      _this.onNewCard = function () {
        _this.props.cardState.inputValues = {};
      };
      _this.onNextClick = function () {
        _this.nextCardWasClicked = true;
        _this.onNewCard();
        if (_state.DeckUI.user.vocabCardAudio && !_state.AppUI.user.blockMediaAccess) {
          _state.DeckUI.advanceCard(_this.props.card, _this.props.cardState, _this.props.userCard, {
            score: _constants.Constants.GOOD_SCORE,
            xp: 1,
            xpXPos: _state.DeckUI.layout.quarterDeckWidth * 2
          });
        } else {
          _state.DeckUI.advanceCard(_this.props.card, _this.props.cardState, _this.props.userCard);
        }
      };
      _this.afterVideoPlayback = function () {
        _state.DeckUI.playUserInputAfterRevealVideo(_this.props.card, _this.props.cardState);
      };
      _this.onRefreshSentence = function () {
        _this.loadingSentenceHasTimedOut = false;
        _state.DeckUI.enrichSentence(_this.props.card, false);
      };
      _this.selectNextWordAssociation = function () {
        if ((0, _lodash.last)(_this.props.card.wordAssociationIds) !== _this.focusedWordAssociationId) {
          var currentIndex = _this.props.card.wordAssociationIds.indexOf(_this.focusedWordAssociationId);
          _this.onInputFocus(_this.props.card.wordAssociationIds[currentIndex + 1]);
        }
      };
      setTimeout(function () {
        return _this.loadingSentenceHasTimedOut = true;
      }, 5000);
      _state.DeckUI.enrichSentence(_this.props.card);
      _this.resetCardStateDisposer = (0, _mobx.autorun)(function () {
        if (!_this.props.cardState.revealed) {
          _this.submittedAnswer = false;
          _this.submittedInputValuesCorrect = undefined;
          _this.nextCardWasClicked = false;
          _this.resetWarnings();
        }
      });
      _this.disposer = (0, _mobx.autorun)(function () {
        if (_this.sentenceLoaded && _this.props.card && _this.props.card.id !== _this.cardId) {
          _this.cardId = _this.props.card.id;
          if (!_this.props.cardState.revealed && !_this.props.cardState.pendingReveal) _this.onNewCard();
          var wa = _this.props.card.sentence.wordAssociations.filter(function (item) {
            return _this.props.card.wordAssociationIds.includes(item.id);
          });
          var firstWordAssociation = (0, _lodash.sortBy)(wa, function (item) {
            return item.position;
          })[0];
          if (firstWordAssociation) {
            _this.focusedWordAssociationId = firstWordAssociation.id;
          }
        }
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "inputValuesCorrect",
      get: function get() {
        var _this2 = this;
        if (this.submittedAnswer) {
          return this.submittedInputValuesCorrect;
        } else {
          var incorrect = this.props.card.wordAssociationIds.find(function (id) {
            return !_this2.props.cardState.inputValues[id] || _state.DeckUI.normalizeString(_this2.props.cardState.inputValues[id]) !== _state.DeckUI.normalizeString(_this2.targetByWordAssociationId(id));
          });
          return this.sentenceLoaded && (0, _utils.isBlank)(incorrect);
        }
      }
    }, {
      key: "inputValuesCorrectByWordAssociationId",
      get: function get() {
        var _this3 = this;
        var res = {};
        this.props.card.wordAssociationIds.map(function (id) {
          res[id] = {
            correct: _this3.props.cardState.revealed && !_this3.nextCardWasClicked && _state.DeckUI.normalizeString(_this3.props.cardState.inputValues[id]) === _state.DeckUI.normalizeString(_this3.targetByWordAssociationId(id)),
            incorrect: _this3.props.cardState.revealed && !_this3.nextCardWasClicked && _state.DeckUI.normalizeString(_this3.props.cardState.inputValues[id]) !== _state.DeckUI.normalizeString(_this3.targetByWordAssociationId(id))
          };
        });
        return res;
      }
    }, {
      key: "inputValuesMatchSynonym",
      get: function get() {
        var _this4 = this;
        if ((0, _utils.isBlank)(this.props.cardState.textEntry)) {
          return false;
        }
        var res = [];
        this.props.card.wordAssociationIds.map(function (id) {
          var _this4$wordAssociatio;
          res.push(_this4.props.cardState.revealed && !_this4.nextCardWasClicked && _state.DeckUI.normalizeString(_this4.props.cardState.inputValues[id]) === _state.DeckUI.normalizeString(_this4.targetByWordAssociationId(id)) || (0, _lodash.some)((_this4$wordAssociatio = _this4.wordAssociationById(id)) === null || _this4$wordAssociatio === void 0 || (_this4$wordAssociatio = _this4$wordAssociatio.word) === null || _this4$wordAssociatio === void 0 || (_this4$wordAssociatio = _this4$wordAssociatio.rootWord) === null || _this4$wordAssociatio === void 0 || (_this4$wordAssociatio = _this4$wordAssociatio.childrenSynonymsString) === null || _this4$wordAssociatio === void 0 ? void 0 : _this4$wordAssociatio.split(', ').map(function (synonym) {
            return _state.DeckUI.normalizeString(_this4.props.cardState.inputValues[id]) === _state.DeckUI.normalizeString(synonym);
          })));
        });
        return (0, _lodash.every)(res);
      }
    }, {
      key: "inputValuesCorrectWithoutAccents",
      get: function get() {
        var _this5 = this;
        var incorrectWithoutAccents = this.props.card.wordAssociationIds.find(function (id) {
          return !_this5.props.cardState.inputValues[id] || (0, _lodash.deburr)(_state.DeckUI.normalizeString(_this5.props.cardState.inputValues[id])) !== (0, _lodash.deburr)(_state.DeckUI.normalizeString(_this5.targetByWordAssociationId(id)));
        });
        return this.sentenceLoaded && (0, _utils.isBlank)(incorrectWithoutAccents);
      }
    }, {
      key: "inputValuesCorrectWithoutCasing",
      get: function get() {
        var _this6 = this;
        var incorrectWithoutCasing = this.props.card.wordAssociationIds.find(function (id) {
          return !_this6.props.cardState.inputValues[id] || _state.DeckUI.normalizeString(_this6.props.cardState.inputValues[id], true) !== _state.DeckUI.normalizeString(_this6.targetByWordAssociationId(id), true);
        });
        return this.sentenceLoaded && (0, _utils.isBlank)(incorrectWithoutCasing);
      }
    }, {
      key: "icons",
      get: function get() {
        if (this.showWordCard) {
          return [];
        }
        if (this.props.icons) {
          return this.props.icons;
        }
        var ary = [];
        if (!this.props.cardState.revealed) {
          ary.push('toggleMicrophone');
        }
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (this.props.cardState.revealed && _state.DeckUI.showDeckGrammarIcon) {
          ary.push('deckGrammar');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        return ary;
      }
    }, {
      key: "topSectionText",
      get: function get() {
        if ((0, _utils.isPresent)(this.props.card.prompt)) {
          return this.props.card.prompt;
        } else if ((0, _utils.isPresent)(this.props.card.sentence)) {
          return this.props.card.sentence.sourceTextForUser(_state.DeckUI.user);
        }
      }
    }, {
      key: "topSectionLanguageId",
      get: function get() {
        if ((0, _utils.isPresent)(this.props.card.sentence)) {
          return this.props.card.sentence.sourceTextForUserLanguageId(_state.DeckUI.user);
        }
      }
    }, {
      key: "sectionHeight",
      get: function get() {
        var height;
        height = _state.DeckUI.layout.heightForCardSections(this.numSections, 0, false);
        if (_state.DeckUI.layout.isNative && _state.DeckUI.layout.keyboardVisible) {
          var padding = _state.DeckUI.layout.isAndroid && !_state.DeckUI.layout.hasNativeMenuBar ? 50 : 30;
          height = height + _state.DeckUI.layout.buttonHeight - padding;
        }
        if (this.showUserInput) {
          var userInputHeight = _state.DeckUI.layout.userInputHeight / this.numSections;
          return height - userInputHeight;
        } else {
          return height;
        }
      }
    }, {
      key: "showWordCard",
      get: function get() {
        return this.props.inView && this.props.card && this.props.card.sentence && this.props.card.sentence.state.selectedWordAssociationId;
      }
    }, {
      key: "sentenceLoaded",
      get: function get() {
        return this.props.card && this.props.card.sentence && this.props.card.sentence.wordAssociations && this.props.card.sentence.wordAssociations.length > 0;
      }
    }, {
      key: "numSections",
      get: function get() {
        return this.props.cardState.revealed ? 3 : 2;
      }
    }, {
      key: "showUserInput",
      get: function get() {
        return !this.props.alwaysShowTextInput && _state.DeckUI.user.vocabCardAudio;
      }
    }, {
      key: "showRefreshButton",
      get: function get() {
        return (0, _utils.isBlank)(this.props.card.sentence.enrichedWords) && this.loadingSentenceHasTimedOut;
      }
    }, {
      key: "userAnswer",
      get: function get() {
        var _card$sentence;
        var _this$props2 = this.props,
          card = _this$props2.card,
          cardState = _this$props2.cardState;
        return (0, _utils.formatBlankAnswer)((_card$sentence = card.sentence) === null || _card$sentence === void 0 ? void 0 : _card$sentence.wordAssociations, function (association) {
          var _card$wordAssociation, _cardState$inputValue;
          return (_card$wordAssociation = card.wordAssociationIds) !== null && _card$wordAssociation !== void 0 && _card$wordAssociation.includes(association.id) ? (_cardState$inputValue = cardState.inputValues) === null || _cardState$inputValue === void 0 ? void 0 : _cardState$inputValue[association.id] : null;
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.disposer && this.disposer();
        this.resetCardStateDisposer && this.resetCardStateDisposer();
      }
    }, {
      key: "resetWarnings",
      value: function resetWarnings() {
        this.showMultipleWordsWarning = false;
        this.showLetterCaseWarning = false;
        this.showAccentWarning = false;
        this.showSynonymWarning = false;
      }
    }, {
      key: "evaluateVocabOnKeystroke",
      get: function get() {
        return _state.DeckUI.user.evaluateVocabOnKeystroke && !this.props.blockEvaluateVocabOnKeystroke;
      }
    }, {
      key: "inputNeedsMoreWords",
      get: function get() {
        var _this7 = this;
        return !(0, _utils.isBlank)(this.props.card.wordAssociationIds.filter(function (id) {
          var _DeckUI$normalizeStri, _DeckUI$normalizeStri2;
          var inputLength = (_DeckUI$normalizeStri = _state.DeckUI.normalizeString(_this7.props.cardState.inputValues[id])) === null || _DeckUI$normalizeStri === void 0 ? void 0 : _DeckUI$normalizeStri.split(' ').length;
          return (0, _utils.isPresent)(_this7.props.cardState.inputValues[id]) && inputLength > 0 && inputLength < ((_DeckUI$normalizeStri2 = _state.DeckUI.normalizeString(_this7.targetByWordAssociationId(id))) === null || _DeckUI$normalizeStri2 === void 0 ? void 0 : _DeckUI$normalizeStri2.split(' ').length);
        }));
      }
    }, {
      key: "possibleArrowBoxes",
      get: function get() {
        var defaultArrowBoxes = ['translateVocab'];
        if (this.props.possibleArrowBoxes) {
          return [].concat(defaultArrowBoxes, _toConsumableArray(this.props.possibleArrowBoxes));
        }
        return defaultArrowBoxes;
      }
    }, {
      key: "currentArrowBox",
      get: function get() {
        if (this.props.currentArrowBox) {
          return this.props.currentArrowBox;
        }
        if (!this.props.cardState.revealed && this.showUserInput && !(_state.DeckUI.userInputStore.isRecording || _state.DeckUI.userInputStore.hasRecording)) {
          return 'translateVocab';
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          inputValues: this.props.cardState.inputValues,
          focusedWordAssociationId: this.focusedWordAssociationId,
          cardId: this.cardId,
          caretPosition: this.caretPosition,
          inputValuesCorrect: this.inputValuesCorrect,
          sectionHeight: this.sectionHeight,
          topSectionText: this.topSectionText,
          onInputChange: this.onInputChange,
          onInputFocus: this.onInputFocus,
          onCharacterClick: this.onCharacterClick,
          wordAssociationById: this.wordAssociationById,
          targetByWordAssociationId: this.targetByWordAssociationId,
          onNewCard: this.onNewCard,
          nativeCardSectionHeight: this.nativeCardSectionHeight,
          onNextClick: this.onNextClick,
          possibleArrowBoxes: this.possibleArrowBoxes,
          currentArrowBox: this.currentArrowBox,
          showWordCard: this.showWordCard,
          showUserInput: this.showUserInput,
          afterVideoPlayback: this.afterVideoPlayback,
          icons: this.icons,
          showRefreshButton: this.showRefreshButton,
          onRefreshSentence: this.onRefreshSentence,
          showAccentWarning: this.showAccentWarning,
          showSynonymWarning: this.showSynonymWarning,
          showMultipleWordsWarning: this.showMultipleWordsWarning,
          showLetterCaseWarning: this.showLetterCaseWarning,
          onShowAnswer: this.onShowAnswer,
          onSubmit: this.onSubmit,
          onCaretPositionChange: this.onCaretPositionChange,
          inputValuesCorrectByWordAssociationId: this.inputValuesCorrectByWordAssociationId,
          selectNextWordAssociation: this.selectNextWordAssociation,
          topSectionLanguageId: this.topSectionLanguageId,
          evaluateVocabOnKeystroke: this.evaluateVocabOnKeystroke,
          userAnswer: this.userAnswer
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "focusedWordAssociationId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "cardId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "caretPosition", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "submittedAnswer", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "submittedInputValuesCorrect", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "loadingSentenceHasTimedOut", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "showAccentWarning", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "showSynonymWarning", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "showMultipleWordsWarning", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "showLetterCaseWarning", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "nextCardWasClicked", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "inputValuesCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inputValuesCorrect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "inputValuesCorrectByWordAssociationId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inputValuesCorrectByWordAssociationId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "inputValuesMatchSynonym", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inputValuesMatchSynonym"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "inputValuesCorrectWithoutAccents", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inputValuesCorrectWithoutAccents"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "inputValuesCorrectWithoutCasing", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inputValuesCorrectWithoutCasing"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "topSectionText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "topSectionText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "topSectionLanguageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "topSectionLanguageId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showWordCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showWordCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentenceLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentenceLoaded"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "numSections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numSections"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showUserInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showUserInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showRefreshButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showRefreshButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "evaluateVocabOnKeystroke", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "evaluateVocabOnKeystroke"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "inputNeedsMoreWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inputNeedsMoreWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "possibleArrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "possibleArrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentArrowBox"), _class2.prototype), _class2)) || _class;
};
SentenceTranslateCardWrapper.displayName = 'SentenceTranslateCardWrapper';
var _default = exports["default"] = SentenceTranslateCardWrapper;